import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { fetchUnVerifiedInvoices } from 'slices/invoiceSlice';
import { Controller, useForm } from 'react-hook-form';
import moment from 'moment';
import { Select } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { fetchTypes } from 'slices/typeSlice';
import ClientInvoiceViewList from './ClientViewList';
import { fetchAppointClientsListPage } from 'slices/invoiceSlice';

const InvoicePayments = () => {
    const dispatch = useDispatch();
    const startDateRef = React.useRef(null);
    const endDateRef = React.useRef(null);
    const [clientState, setClientState] = useState([]);

    const defaultValues = {
        invoicing_period: "",
        start_date: "",
        end_date: "",
        client_ids: [],
    };

    const { clearErrors, handleSubmit, watch, formState: { errors }, control, setValue, reset, getValues } = useForm({
        defaultValues: defaultValues
    });

    useEffect(() => {
        setValue("client_ids", []);
    }, []);

    const filteredAccountsLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchTypes(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));

        return {
            options: result.data.map((item) => ({
                value: item.id,
                label: item.name,
            })),
            hasMore: page !== result?.last_page,
            additional: { page: page + 1 },
        };
    };

    const handleResetFields = () => {
        reset(defaultValues);
        dispatch(fetchAppointClientsListPage(1, defaultValues));
    };

    const onSubmit = (data) => {
        dispatch(fetchAppointClientsListPage(1, data));
    };

    const invoiceOption = [
        { label: "Weekly", value: "weekly" },
        { label: "Bi-weekly", value: "bi-weekly" },
        { label: "Monthly", value: "monthly" }
    ];




    return (
        <div className="content" style={{}}>
            <div className="row_main_head">
                <h2 className={`main_heading`}>Billing</h2>
            </div>
            <div className="card_table">
                <form className="invoicing_form">
                    <div className='billings row_Invoice'>
                        <div className="row-primary">
                            <h2>Invoicing Period</h2>
                            <Controller
                                name="invoicing_period"
                                control={control}
                                render={({ field }) => (
                                    <div className='select_box' style={{ width: "100%" }}>
                                        <Select
                                            name="invoicing_period"
                                            options={invoiceOption}
                                            value={invoiceOption.find(opt => opt.value === field.value) || ""}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="row-primary">
                            <h2>Start Date</h2>
                            <Controller
                                name="start_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image">
                                        <input ref={startDateRef} id='start_date' type="date" name='start_date' placeholder='Start Date' required
                                            {...field}
                                            value={field.value}
                                            // onChange={(e) => field.onChange(moment(new Date(e.target.value)).format("YYYY-MM-DD"))}
                                            onChange={(e) => field.onChange(moment(e.target.value, "YYYY-MM-DD").format("YYYY-MM-DD"))}
                                        />
                                        <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                    </div>
                                )} />
                        </div>
                        <div className="row-primary">
                            <h2>End Date</h2>
                            <Controller
                                name="end_date"
                                control={control}
                                render={({ field }) => (
                                    <div className="input-image ">
                                        <input ref={endDateRef} type="date" name='end_date' placeholder='End Date' required
                                            {...field}
                                            value={field.value}
                                            onChange={(e) => field.onChange(moment(e.target.value, "YYYY-MM-DD").format("YYYY-MM-DD"))}
                                        />
                                        <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                    </div>
                                )} />
                        </div>
                        <div className="row-primary">
                            <h2>Client</h2>
                            <Controller
                                name="client_ids"
                                control={control}
                                render={({ field }) => (
                                    <div style={{ width: "100%" }}>
                                        <AsyncPaginate
                                            menuPlacement='auto'
                                            isMulti
                                            styles={{
                                                ...selectCustomStyles,
                                            }}
                                            value={clientState || []}
                                            loadOptions={filteredAccountsLoadOptions}
                                            isClearable
                                            escapeClearsValue
                                            onChange={(obj) => {
                                                setClientState(obj);
                                                field.onChange(obj.map((opt) => opt.value));
                                            }}
                                            additional={{
                                                page: 1,
                                            }}
                                        />
                                        {
                                            errors?.client_ids?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.client_ids?.message} />
                                            </div>
                                        }
                                    </div>
                                )}
                            />
                        </div>
                    </div>

                    <div className="row-primary btns_area row_10 mb-0">
                        <SubmitButton handleSubmit={handleSubmit(onSubmit)} btnText="Search" className={'green'} />
                        <SubmitButton buttonType="button" className={'lightBlue'} btnText="Reset" handleSubmit={handleResetFields} />
                    </div>
                </form>

                <ClientInvoiceViewList />
            </div>
        </div>
    );
}

export default InvoicePayments